import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import { Navigation, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'
import 'swiper/css/scrollbar'
import 'swiper/swiper-bundle.css'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import cn from 'utils/cn'
import img from 'resources/images/groupSwiper1.jpg'
import img2 from 'resources/images/g3.jpg'
import img3 from 'resources/images/g2.jpg'
import img4 from 'resources/images/innovative.jpg'
export default function OurGroup() {
    const [swiper, setSwiper] = useState(null)
    const [slideIndex, setSlideIndex] = useState(null)
    const { t } = useTranslation()
    const screen = useMediaQuery('(min-width:1280px)')
    const lgScreen = useMediaQuery('(min-width:1024px)')
    const mdScreen = useMediaQuery('(min-width:768px)')
    const space = screen ? 520 : lgScreen ? 480 : mdScreen ? 638 : 300
    const list = [
        {
            img: img,
            title: 'ourGroup.competitiveEdgesListTitle1',
            desc: 'ourGroup.competitiveEdgesLisDescription1',
        },
        {
            img: img2,
            title: 'ourGroup.competitiveEdgesListTitle2',
            desc: 'ourGroup.competitiveEdgesLisDescription2',
        },
        {
            img: img3,
            title: 'ourGroup.competitiveEdgesListTitle3',
            desc: 'ourGroup.competitiveEdgesLisDescription3',
        },
        {
            img: img4,
            title: 'ourGroup.competitiveEdgesListTitle4',
            desc: 'ourGroup.competitiveEdgesLisDescription4',
        },
    ]
    const navigate = useNavigate()
    useEffect(() => {
        setTimeout(() => {
            setSlideIndex(0)
        })
    }, [])
    return (
        <div className=' py-8 md:py-15'>
            <h2 className='text-[#333d47] text-center font-bold pb-12 text-2xl md:text-3xl lg:text-4xl '>
                {t('home.aboutUs')}
            </h2>
            <div className='w-full overflow-hidden'>
                <Swiper
                    //   loop={true}
                    modules={[Navigation, Autoplay]}
                    autoplay={{
                        delay: 5000,
                        disableOnInteraction: false,
                    }}
                    spaceBetween={30}
                    slidesPerView={1} // 关键参数：显示1.5个幻灯片
                    centeredSlides={true} // 关键参数：居中显示
                    className='w-full max-w-[1000px]'
                    style={{
                        // 确保滑动区域可见
                        overflow: 'visible',
                        padding: '0 60px', // 为两侧留出空间
                    }}
                    onSwiper={(swiper) => {
                        setSwiper(swiper)
                    }}
                    onActiveIndexChange={(swiper) => {
                        setSlideIndex(swiper.realIndex)
                    }}
                    initialSlide={0}
                >
                    {list.map((item, index) => (
                        <SwiperSlide key={index}>
                            <div onClick={() => navigate('/about-us')} className='cursor-pointer'>
                                <div className='flex gap-6 w-full pb-4 text-[#333d47] flex-col md:flex-row'>
                                    <div className='h-[306px] flex-1'>
                                        <img
                                            src={item.img}
                                            alt=''
                                            className='w-full h-full object-center object-cover'
                                        />
                                    </div>
                                    <div className='flex-1'>
                                        <h3 className='text-2xl font-bold pb-4'>{t(item.title)}</h3>
                                        <p className='text-base font-medium md:text-lg'>{t(item.desc)}</p>
                                    </div>
                                </div>
                                {/* <div className=' items-center gap-1 hidden md:flex'>
                                    <div className='bg-[#941e26] size-4 rounded-[8px]'></div>
                                    <div className='relative flex-1 h-1  bg-[#efefef]'>
                                        <div
                                            className={cn(
                                                'absolute top-0 left-0 w-0 h-full bg-[#941e26] transition-all duration-[50000] ease-in-out',
                                                slideIndex === index && 'w-full',
                                            )}
                                        ></div>
                                    </div>
                                </div> */}
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    )
}
